import { Outlet, useNavigate } from "react-router-dom";
import Brand from "../../../brand/brand.component";
import BrandFullName from "../../../brand_fullname/brand_fullname.component";
import "./hostHome.styles.scss";
import { useContext, useEffect } from "react";
import { AffiliateContext } from "../../../../contexts/affiliate.context";
const HostHome = () => {
  const navigate = useNavigate();
  const { affiliate } = useContext(AffiliateContext);
  useEffect(() => {
    if (affiliate === "") {
      navigate("/");
    }
  }, []);
  const handleLogout = () => {
    localStorage.removeItem("affiliate");
    localStorage.removeItem("hotelID");
    localStorage.removeItem("affiliateType");
    window.location.reload();
  };
  return (
    <div className="host-home-container">
      <div className="host-home-top">
        {window.innerWidth > 1024 ? <BrandFullName /> : <Brand />}
        <span className="host-home-title">HOST PAGE</span>
        <span className="logout-button" onClick={handleLogout}>
          Logout
        </span>
      </div>
      <Outlet />
    </div>
  );
};
export default HostHome;
